import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  admin,
  announce,
  announcement,
  apptime,
  arrow,
  help,
  history,
  link,
  logout,
  overall,
  recharge,
  report,
  side_bar,
  winning,
  withdraw,
  withdrawIcon,
} from "../../assets/img";
import Footer from "../Footer/Footer";
import useStore from "../../Screen/redux/store/useStore";
import { post } from "../../Services/ApiHandler";
import { ICON_FILTER, URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import { Toast } from "../Toast";
import CustomScroll from "../CustomScroll";
import CommonPopup from "../CommonPopup";
import { MaskIcon } from "../MaskIcon";

const MobileNavbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { role, user, permissions } = useStore();
  const menuRef = useRef(null);
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  console.log("rolerole", role);

  const scrollRef = useRef(null);

  useEffect(() => {
    const fromFooter = location.state?.fromFooter;
    const savedPosition = sessionStorage.getItem("profileScrollPosition");

    console.log("fromFooter:", fromFooter, "savedPosition:", savedPosition);

    if (scrollRef.current) {
      if (fromFooter) {
        scrollRef.current.scrollTop = 0;
        navigate(location.pathname, { state: { fromFooter: false } });
      } else if (savedPosition) {
        // Delay to ensure DOM is fully rendered
        setTimeout(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTop = Number(savedPosition);
          }
          sessionStorage.setItem("profileScrollPosition", 0);
        }, 0);
      }
    }
  }, [location]);

  useEffect(() => {
    const content = scrollRef.current;
    if (content) {
      content.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (content) {
        content.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const handleScroll = () => {
    const position = scrollRef.current ? scrollRef.current.scrollTop : 0;
    sessionStorage.setItem("profileScrollPosition", position);
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("isReload", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    if (window.innerWidth > 777 && location.pathname !== "/dashboard") {
      navigate("/dashboard");
    }

    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [location.pathname, navigate]);

  // ✅ Menu items mapped to module_code (from your backend permission data)
  const profiledata = [
    {
      icon: admin,
      title: "DASHBOARD ",
      img: arrow,
      path: "/dashboard",
      module_code: "dashboard",
    },
    {
      icon: admin,
      title: "ADMINS",
      img: arrow,
      path: "/admin",
      module_code: "admins",
    },
    {
      icon: admin,
      title: "ROLES MAPPING",
      img: arrow,
      path: "/role",
      module_code: "role_maping",
    },
    {
      icon: admin,
      title: "CLIENTS",
      img: arrow,
      path: "/client-list",
      module_code: "client",
    },
    {
      icon: recharge,
      title: "ADMIN RECHARGE",
      img: arrow,
      path: "/admin-recharge",
      module_code: "admin_recharge",
    },
    {
      icon: history,
      title: "RECHARGE HISTORY",
      img: arrow,
      path: "/recharge-history",
      module_code: "recharge_history",
    },
    {
      icon: withdrawIcon,
      title: "WITHDRAW HISTORY",
      img: arrow,
      path: "/withdraw-history",
      module_code: "widraw_history",
    },
    {
      icon: announce,
      title: "ANNOUNCE RESULT",
      img: arrow,
      path: "/announce-result",
      module_code: "announce_result",
    },
    {
      icon: overall,
      title: "OVERALL RESULTS",
      img: arrow,
      path: "/overall-result",
      module_code: "overall_result",
    },
    {
      icon: report,
      title: "REPORTS",
      img: arrow,
      path: "/report",
      module_code: "reports",
    },
    {
      icon: overall,
      title: "COMMISSION HISTORY",
      img: arrow,
      path: "/commission",
      module_code: "commission_history",
    },
    {
      icon: winning,
      title: "ANNOUNCEMENT",
      img: arrow,
      path: "/announcement",
      module_code: "announcements",
    },
    {
      icon: winning,
      title: "HOLIDAY UPDATE",
      img: arrow,
      path: "/holiday-update",
      module_code: "holiday_update",
    },
    {
      icon: link,
      title: "LINKS",
      img: arrow,
      path: "/add-link",
      module_code: "links",
    },
    {
      icon: overall,
      title: "LOT PRICE DETAILS",
      img: arrow,
      path: "/lot-price",
      module_code: "lot_price_details",
    },
    {
      icon: overall,
      title: "PRICE DETAILS",
      img: arrow,
      path: "/cash-agency",
      module_code: "price_details",
    },
    {
      icon: apptime,
      title: "APP TIME SETTINGS",
      img: arrow,
      path: "/app-time",
      module_code: "app_time_setting",
    },
    {
      icon: help,
      title: "HELP & SUPPORT",
      img: arrow,
      path: "/help-support",
      module_code: "help_and_support",
    },
  ];

  // ✅ Click outside closes dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ✅ Logout logic
  const handleLogout = async () => {
    console.log("[MobileNavbar] 📱 Manual logout initiated.");
    setLoading(true);
    try {
      const res = await post(URLS.LOGOUT);
      console.log("[MobileNavbar] Logout response received:", res);
      if (res.status === "success") {
        Toast(res.message || "Logout Successfully!");
      }
    } catch (err) {
      console.error("[MobileNavbar] Logout API error:", err);
    }
    setTimeout(() => {
      console.log(
        "[MobileNavbar] Finalizing manual logout: Clearing storage and navigating.",
      );
      setLoading(false);
      setPopup(false);
      sessionStorage.clear();
      localStorage.removeItem("token");
      navigate("/", { replace: true });
    }, 1000);
  };

  // ✅ Filter menu based on permissions
  const filteredMenu = profiledata.filter((item) => {
    // Admin & Super Admin → allow all
    if (role === true) {
      return true;
    }

    const hasPermission = permissions?.some(
      (p) => p.module_code === item.module_code,
    );

    return hasPermission;
  });

  const dropdownItems = [
    { title: "DELETE DATA", path: "/delete-data", module_code: "delete_data" },
    {
      title: "CLIENT ACTIVITY",
      path: "/client-activity",
      module_code: "client_activity",
    },
    {
      title: "BLOCKED CLIENT LIST",
      path: "/blocked-client",
      module_code: "blocked_client_list",
    },
    {
      title: "DRAW STATUS",
      path: "/draw-status",
      module_code: "draw_status",
    },
  ];

  const filteredDropdown = dropdownItems.filter((item) => {
    if (role === true) return true;

    const hasPermission = permissions?.some(
      (p) => p.module_code === item.module_code,
    );

    return hasPermission;
  });

  return (
    <div className="dashRightView">
      <CustomScroll ref={scrollRef}>
        <div className="container_overalls">
          {/* Sidebar toggle */}
          {filteredDropdown.length > 0 && (
            <div className="d-flex ac-je my-2">
              <MaskIcon
                src={side_bar}
                width={25}
                height={10}
                onClick={() => setShowMenu((prev) => !prev)}
              />
            </div>
          )}

          {/* Dropdown Menu */}
          {showMenu && filteredDropdown.length > 0 && (
            <>
              <div
                className="dropdown-overlay"
                onClick={() => setShowMenu(false)}
              ></div>
              <div style={{ width: "90%" }} className="dropdown-menu-custom" ref={menuRef}>
                {filteredDropdown.map((item, index) => (
                  <div
                    key={index}
                    className={
                      index === filteredDropdown.length - 1
                        ? "dropdown-item1"
                        : "dropdown-item"
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(item.path);
                    }}
                  >
                    <p className="f3 fs-sm-16 fs-md-15 fs-lg-16 primary mb-0">
                      {item.title}
                    </p>
                    <MaskIcon src={arrow} width={6} height={12} alt="arrow"   />
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Main Menu */}
          <div className="profile-list">
            {filteredMenu.map((item, index) => (
              <div
                key={index}
                className="d-flex ac-jb py-3 profile-item"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  // Save current scroll position before navigating
                  const position = scrollRef.current
                    ? scrollRef.current.scrollTop
                    : 0;
                  sessionStorage.setItem("profileScrollPosition", position);
                  navigate(item.path);
                }}
              >
                <div className="d-flex ac-js gap-3">
                  <MaskIcon src={item.icon} height={19} width={18} alt="icon"   />
                  <p className="f3 dashboard_title1 fs-sm-16 fs-md-18 fs-lg-20 primary mb-0">
                    {item.title}
                  </p>
                </div>
                <MaskIcon src={item.img} height={15} width={9} alt="arrow"  />
              </div>
            ))}
          </div>

          {/* Logout Section */}
          <div
            style={{ marginBottom: 10, marginTop: 10 }}
            className="d-flex ac-jc py-3 gap-1"
            onClick={() => setPopup(true)}
          >
            <MaskIcon src={logout} height={15} width={15} alt="logout"  />
            <p className="f3 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 logout_text primary">
              LOGOUT
            </p>
          </div>

          {/* Logout Confirmation Popup */}
          {/* {popup && (
            <div className="img-popup-design">
              <div className="img-popup">
                <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary1">
                  Are you sure, you want to logout?
                </p>
                <div className="d-flex ac-jb px-2 mt-4 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                  <button
                    onClick={() => setPopup(false)}
                    className="no-btn w-45"
                  >
                    No
                  </button>
                  <button
                    onClick={handleLogout}
                    className="yes-btn f2 w-45 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                          style={{ color: "black", padding: 6 }}
                        ></span>
                      </>
                    ) : (
                      "Confirm"
                    )}
                  </button>
                </div>
              </div>
            </div>
          )} */}

          <CommonPopup
            isOpen={popup}
            message="Are you sure, you want to logout?"
            onClose={() => setPopup(false)}
            onConfirm={handleLogout}
            loading={loading}
          />
        </div>
      </CustomScroll>
      <Footer />
    </div>
  );
};

export default MobileNavbar;
